import { Scrollbar } from '../core'

$.fn.TeamMember = function(item) {
  let self = this

  if (self.data('team-member')) {
    return self.data('team-member')
  }

  self.close_btn = self.find('.team-member__close-btn')

  self.open = function() {
    self.attr('aria-hidden', 'false')
  }

  self.close = function() {
    item.close()
    self.attr('aria-hidden', 'true')
  }

  self.background_clicked = function(e) {
    if (e.target == e.currentTarget) {
      self.close()
    }
  }

  return function() {
    new Scrollbar(self.find('.team-member__content-scroller'))
    self.on('click', self.background_clicked)
    self.close_btn.on('click', self.close)
    self.data('team-member', self)
    return self
  }()
}

$.fn.GridTeamItem = function() {
  let self = this

  if (self.data('grid-team-item')) {
    return self.data('grid-team-item')
  }

  self.content = self.find('.team-member').TeamMember(self)

  self.open = function() {
    $('body').addClass('--no-scroll')
    $('.app').append(self.content)
    requestAnimationFrame(function() {
      self.attr('aria-expanded', 'true')
      self.content.open()
    })
  }

  self.close = function() {
    self.attr('aria-expanded', 'false')
    $('body').removeClass('--no-scroll')
  }

  return function() {
    self.data('grid-team-item', self)
    self.on('click', self.open)
    return self
  }()
}
